// @styles
require('./aggregatorCredentialsPSD2Styles.scss')

// @vendors
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
const PropTypes = require('prop-types');

// @components
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import { OKButton } from 'components/commons/OKButton/OKButton';

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
import Storage from 'utilities/storage';

// @constants
import { STEP } from 'constants/aggregator/consentViewType';
import { SELECTED_BANK } from 'constants/aggregator/localStorageKeys';
const NO_CONSENT_REQUIRED = 'A1'


class AggregatorCredentialsPSD2Ok extends Component {

    constructor() {
        super();
        const { bankName, bankLogo, bankManagement, bankCode, scrapingCredentials } = Storage.localStorage.get(SELECTED_BANK) || {};
        this.state = { bankName, bankLogo, bankManagement, bankCode, scrapingCredentials }
        this.handleGoToCreateConsent = this.handleGoToCreateConsent.bind(this);
    }

    handleGoToCreateConsent = () => this.props.history.push(`/myprofile/global/entities/consent/${STEP}`)

    buildButtons = (bankManagement) => {
        const { bankCode, scrapingCredentials } = this.state;
        const credentialsButton = scrapingCredentials ? <div/> : <OKButton modifier="secondary" onClick={()=> this.props.history.push(`/myprofile/global/entities/add/credentials/scrapping/${bankCode}`)} targetBlank={false} >{formatText('aggregatorPSD2-consentOkCredentialsButton')}</OKButton>;

        return bankManagement === NO_CONSENT_REQUIRED?
            <div className="aggregator-accept-consent-ok__buttons">
                {credentialsButton}
                <OKButton modifier="link-complementary" onClick={()=> this.props.history.push("/myprofile/global")}>{formatText('aggregatorPSD2-consentOkGPButton')}</OKButton>
            </div>
        : <div className="aggregator-psd2-credentials__buttons-wrapper">
            <OKButton onClick={this.handleGoToCreateConsent}>
                <FormattedText value="aggregatorPSD2-credentialsOkButtonText" />
            </OKButton>
        </div>
    }

    render() {
        const { bankName, bankLogo, bankManagement } = this.state;
        const buttons = this.buildButtons(bankManagement);
        const informationText = bankManagement === NO_CONSENT_REQUIRED ? "aggregatorPSD2-credentialsOkInformationA1" : "aggregatorPSD2-credentialsOkInformation";
        const buttonIndicationText = bankManagement === NO_CONSENT_REQUIRED ? "aggregatorPSD2-credentialsOkButtonIndicationA1" : "aggregatorPSD2-credentialsOkButtonIndication";

        return (
            <AggregatorAddEntityLayout>
                <OKSectionBox className="aggregator-psd2-credentials col-md-8" title={formatText('aggregatorPSD2-credentialsOkTitle')} icon="success">
                    <div className="aggregator-psd2-credentials__information">
                        <FormattedText value={informationText} />
                    </div>
                    <div className="aggregator-psd2-credentials__button-indications">
                        <FormattedText value={buttonIndicationText} injectedStrings={[bankName || '']} />
                    </div>
                    <div className="aggregator-psd2-credentials__logo-bank-wrapper">
                        <img className="aggregator-psd2-credentials__logo-bank" src={bankLogo} />
                    </div>
                    {buttons}
                </OKSectionBox>
            </AggregatorAddEntityLayout>
        )
    }
}

AggregatorCredentialsPSD2Ok.propTypes = {
    history: PropTypes.object.isRequired,
}

export default withRouter(AggregatorCredentialsPSD2Ok);
